export default {"theme":{"dark":true,"themes":{}}}
